import { gql } from '@apollo/client';

export const EDIT_BLOG_POST_MUTATION = gql`
  fragment CommonBlogPostFieldsForEdit on BlogPost {
    id
    locale
    title
    content
    appSortOrder
    bannerImage {
      id
      url
      formats
    }
    website
    hidden
  }

  mutation EditBlogPost($id: ID!, $data: editBlogPostInput!) {
    updateBlogPost(input: { where: { id: $id }, data: $data }) {
      blogPost {
        ...CommonBlogPostFieldsForEdit
        localizations {
          ...CommonBlogPostFieldsForEdit
        }
      }
    }
  }
`;
